import { DashPlaceholder, Box, Thumbnail } from 'dash-ui';

import PortfolioLockMask, {
  RelativeContainer,
} from 'containers/portfolio/PortfolioLockMask/PortfolioLockMask';
import VerifiedBadge from 'common/components/VerifiedBadge/VerifiedBadge';

import { IPortfolioThumbnailProps } from './PortfolioThumbnailView.interfaces';
import {
  GridBox,
  StyledImage,
  portfolioLockMaskStyle,
  VerifiedBadgeWrapper,
} from './PortfolioThumbnailView.styles';

const PortfolioThumbnailView = ({
  properties,
  portfolio,
  isFolder,
  totalCount,
}: IPortfolioThumbnailProps) => {
  const file = portfolio.property?.mainPropertyMediaFile?.files[0];

  if (isFolder && properties.length > 0) {
    return (
      <GridBox
        w="100%"
        px={2}
        pt={2}
        h={[124, 121, 174, 174]}
        propertiesLength={properties.length}
      >
        {properties.slice(0, 3).map((item, index: number) => (
          <Box
            w="100%"
            key={item._id}
            className={`portfolio item-${index + 1}`}
          >
            <Thumbnail
              file={item.property?.mainPropertyMediaFile?.files[0]}
              label={
                totalCount > 3 && index === 2 ? `+${totalCount - 3}` : undefined
              }
              placeholderProps={{
                borderRadius: [8, 8, 0, 0],
              }}
            />
          </Box>
        ))}
      </GridBox>
    );
  }

  if (!isFolder && file) {
    return (
      <RelativeContainer w="100%" h={[124, 121, 174, 174]} pt={2} px={2}>
        {(portfolio.property?.isMarkedAsVerified || false) && (
          <VerifiedBadgeWrapper>
            <VerifiedBadge isSmall />
          </VerifiedBadgeWrapper>
        )}
        <StyledImage file={file} />
        <PortfolioLockMask css={portfolioLockMaskStyle} portfolio={portfolio} />
      </RelativeContainer>
    );
  }

  return (
    <RelativeContainer w="100%" h={[124, 121, 174, 174]} pt={2} px={2}>
      {(portfolio.property?.isMarkedAsVerified || false) && (
        <VerifiedBadgeWrapper>
          <VerifiedBadge isSmall />
        </VerifiedBadgeWrapper>
      )}
      <DashPlaceholder
        variation="secondary"
        w="100%"
        h="100%"
        borderRadius={[8, 8, 0, 0]}
      />
      <PortfolioLockMask css={portfolioLockMaskStyle} portfolio={portfolio} />
    </RelativeContainer>
  );
};

export default PortfolioThumbnailView;
